<script lang="ts" setup>
import { useElementSize, useWindowScroll } from '@vueuse/core'

import { ToastProvider } from '@shared/ui/toast'
import AppFooter from '@app/layout-parts/AppFooter.vue'
import AppHeader from '@app/layout-parts/AppHeader.vue'

defineOptions({
  name: 'LayoutDefault',
})

const headerSticky = useTemplateRef('headerSticky')
const { height: headerHeight } = useElementSize(headerSticky)

const { y } = useWindowScroll()

const isSticky = computed(() => y.value > headerHeight.value)
</script>

<template>
  <div class="hiring-app">
    <slot name="header">
      <div :style="{ height: `${headerHeight}px` }">
        <div
          ref="headerSticky"
          class="header-sticky"
          :class="{ sticky: isSticky }"
        >
          <AppHeader />
        </div>
      </div>
    </slot>

    <slot />

    <slot name="footer">
      <AppFooter />
    </slot>

    <ToastProvider />
  </div>
</template>

<style scoped lang="scss" src="./default.scss" />
